import installmentCalculatorApi from '../../api/installment-calculator-api';
const INSTALLMENT_CALCULATOR_SET_TECHNICAL_FAILURE = 'INSTALLMENT_CALCULATOR_SET_TECHNICAL_FAILURE';
const INSTALLMENT_CALCULATOR_SET_DURATIONS = 'INSTALLMENT_CALCULATOR_SET_DURATIONS';
const INSTALLMENT_CALCULATOR_SET_MINIMUM_AMOUNT = 'INSTALLMENT_CALCULATOR_SET_MINIMUM_AMOUNT';
const INSTALLMENT_CALCULATOR_SET_MAXIMUM_AMOUNT = 'INSTALLMENT_CALCULATOR_SET_MAXIMUM_AMOUNT';
const INSTALLMENT_CALCULATOR_SET_CALCULATION = 'INSTALLMENT_CALCULATOR_SET_CALCULATION';
const INSTALLMENT_CALCULATOR_SET_LOADING = 'INSTALLMENT_CALCULATOR_SET_LOADING';

const installmentCalculatorState = {
	technicalError: false,
	durations: null,
	maximumAmount: 0,
	minimumAmount: 0,
	calculation: null,
	loading: true
};

const installmentCalculatorActions = {
	init({ commit }, amount) {
		installmentCalculatorApi.init(amount).then(
			(response) => {
				commit(INSTALLMENT_CALCULATOR_SET_DURATIONS, response.data.durations);
				commit(INSTALLMENT_CALCULATOR_SET_MAXIMUM_AMOUNT, response.data.maximumAmount);
				commit(INSTALLMENT_CALCULATOR_SET_MINIMUM_AMOUNT, response.data.minimumAmount);
				commit(INSTALLMENT_CALCULATOR_SET_CALCULATION, response.data.sampleCalculation);
				commit(INSTALLMENT_CALCULATOR_SET_LOADING, false);
			},
			() => {
				commit(INSTALLMENT_CALCULATOR_SET_TECHNICAL_FAILURE);
				commit(INSTALLMENT_CALCULATOR_SET_LOADING, false);
			}
		);
	},
	calculate({ commit }, data) {
		installmentCalculatorApi.calculate(data).then(
			(response) => {
				commit(INSTALLMENT_CALCULATOR_SET_CALCULATION, response.data);
			},
			() => {
				commit(INSTALLMENT_CALCULATOR_SET_TECHNICAL_FAILURE);
			}
		);
	}
};

const installmentCalculatorMutations = {
	[INSTALLMENT_CALCULATOR_SET_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
	},
	[INSTALLMENT_CALCULATOR_SET_DURATIONS](state, durations) {
		state.durations = durations;
	},
	[INSTALLMENT_CALCULATOR_SET_MINIMUM_AMOUNT](state, minimumAmount) {
		state.minimumAmount = minimumAmount;
	},
	[INSTALLMENT_CALCULATOR_SET_MAXIMUM_AMOUNT](state, maximumAmount) {
		state.maximumAmount = maximumAmount;
	},
	[INSTALLMENT_CALCULATOR_SET_CALCULATION](state, calculation) {
		state.calculation = calculation;
	},
	[INSTALLMENT_CALCULATOR_SET_LOADING](state, loading) {
		state.loading = loading;
	}
};

export default {
	namespaced: true,
	state: installmentCalculatorState,
	mutations: installmentCalculatorMutations,
	actions: installmentCalculatorActions
};
